"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _MenuItem = _interopRequireDefault(require("@mui/material/MenuItem/MenuItem.js"));
var _ListItemText = _interopRequireDefault(require("@mui/material/ListItemText/ListItemText.js"));
var _Tooltip = _interopRequireDefault(require("@mui/material/Tooltip/Tooltip.js"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var _default = props => {
  const {
    children,
    innerRef,
    isFocused,
    innerProps
  } = props;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Tooltip.default, {
    title: children || '',
    enterDelay: 500,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuItem.default, {
      buttonRef: innerRef,
      selected: isFocused,
      component: "div",
      ...innerProps,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ListItemText.default, {
        children: children
      })
    })
  });
};
exports.default = _default;